import React, {Fragment, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import FileDropzone from "../../../FileDropzone/FileDropzone";
import {Alert} from "../../../Alert/Alert";
import ConfirmDialog from "../../../Dialog/ConfirmDialog";
import FullScreenDialog from "../../../Dialog/FullScreenDialog";
import NormalDialog from "../../../Dialog/NormalDialog";
import PilFileZoneContentStageOne from "./pilFileZoneContentStageOne";
import PilStageTwoUploadDetails from "./pilStageTwoUploadDetails";
import FilePreview from "../../../FilePreview/FilePreview";
import Legend from "../../../Legend/Legend";
import {Grid, Tooltip} from "@material-ui/core";
import Stack from '@mui/material/Stack';
import {ToggleButton, ToggleButtonGroup} from "@material-ui/lab";
import LockScreenLoading from "../../../LockScreenLoading/LockScreenLoading";
import {fileUpload} from "../../../../dataSource/fileManager";
import {deletePilAttachment, insertPilAttachment,} from "../../../../dataSource/pil";
import ProjectInformationStageTwoForm from "../ProjectInformationStageTwoForm";

const PilFileHistory = (props) => {
    let {
        pilDetails,
        setUpdateFlag,
        uploadable,
        lock
    } = props;

    const dispatch = useDispatch();
    const pilDataRedux = useSelector((state) => state.pilDetailsRedux);
    const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
    const [progressTitle, setProgressTitle] = useState("");
    const [filePreviewDialogOpen, setFilePreviewDialogOpen] = useState(false);
    const [stage, setStage] = useState("1");
    const [stageTwoFiles, setStageTwoFiles] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [stagetwoUploadDialogOpen, setStagetwoUploadDialogOpen] = useState(false);
    const [confirmDialogData, setConfirmDialogData] = useState({
        dialogTitle: "", dialogContent: "", confirmAction: "", cancelAction: "",
    });
    const [filePreviewProperty, SetFilePreviewProperty] = useState(null);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertData, setAlertData] = useState({
        type: "", title: "", content: "",
    });
    const handleToggleChange = (event, value) => {
        if (stage === "1" && !(pilDataRedux !== null && pilDataRedux.uploadFiles && pilDataRedux.uploadFiles.filter((a) => a.stage === "1" && a.status === "Y").length > 0)) {
            return;
        }
        if (value !== null) {
            setStage(value);
        }
    };
    const buildAlert = (data) => {
        setAlertData({
            type: data.type, title: data.title, content: data.content,
        });
        setAlertOpen(true);
    };

    // Confirm dialog
    const confirmDialogHandleOpen = (data) => {
        setConfirmDialogData({
            dialogTitle: data.dialogTitle,
            dialogContent: data.dialogContent,
            confirmAction: data.confirmAction,
            cancelAction: data.cancelAction,
        });

        setConfirmDialogOpen(true);
    };

    const confirmDialogHandleClose = () => {
        setConfirmDialogOpen(false);
    };

    const filePreviewDialogHandleOpen = () => {
        setFilePreviewDialogOpen(true);
    };

    const filePreviewDialogHandleClose = () => {
        setFilePreviewDialogOpen(false);
    };

    // Main Action
    const fileUploadAction = (fileType, acceptedFilesPool) => {
        acceptedFilesPool.map((file) => {
            fileUpload(file).then(async (res) => {
                console.log("*****************************************************************************");
                console.log("Temporary upload File Successful");
                console.log(res);
                console.log("*****************************************************************************");
                await buildFileRecord(fileType, res.data[0]);
            });
        });
    };
    const buildFileRecord = async (type, data) => {
        try {
            const details = {...pilDetails};
            details.uploadFiles = [...details.uploadFiles, data]
            data.stage = stage;
            data.type = stage === "1" ? "stage1" : "stage2";
            await insertPilAttachment(pilDetails.general.pil_seq, data).then(() => {
                setUpdateFlag((prev) => !prev);
                dispatch({
                    type: "HANDLE_PIL_VALUE", data: {...pilDetails, details},
                });
                buildAlert({
                    // Alert Type: success, info, warning, error
                    type: "success",
                    title: "Success Alert",
                    content: "The Project Information List File has been uploaded successfully",
                });
            });
        } catch (err) {
            buildAlert({
                // Alert Type: success, info, warning, error
                type: "error", title: "Error Alert", content: `Error:${err}`,
            });
        }
    };

    const removeFileConfirmAction = (fileRecord) => {
        confirmDialogHandleOpen({
            dialogTitle: "Delete File",
            dialogContent: "Are you sure to delete the uploaded Project Information List?",
            confirmAction: () => {
                deleteFileConfirm(fileRecord);
            },
            cancelAction: confirmDialogHandleClose,
        });
    };

    const deleteFileConfirm = async (fileRecord) => {
        confirmDialogHandleClose();
        try {
            await deletePilAttachment(fileRecord.atth_seq).then((res) => {
                setUpdateFlag((prev) => !prev);
                buildAlert({
                    // Alert Type: success, info, warning, error
                    type: "success",
                    title: "Success Alert",
                    content: "The Project Information List File has been deleted successfully",
                });
            });
        } catch (err) {
            buildAlert({
                // Alert Type: success, info, warning, error
                type: "error", title: "Error Alert", content: `Error:${err}`,
            });
        }
    };

    const viewFileAction = (fileCat, fileSeq, filename) => {
        SetFilePreviewProperty({
            fileCategory: fileCat, fileSequence: fileSeq, filename: filename,
        });
        filePreviewDialogHandleOpen();
    };

    const fileAttachmentPreviewDialogBtn = [];
    const stagetwoDialogHandleClose = () => {
        setStageTwoFiles([]);
        setStagetwoUploadDialogOpen(false);
    };

    useEffect(() => {
    }, []);
    return (<Fragment>
        <LockScreenLoading
            open={lockScreenLoadingOpen}
            circleSize={200}
            progressTitle={progressTitle}
        />
        <Alert
            open={alertOpen}
            alertType={alertData.type}
            alertTitle={alertData.title}
            alertContent={alertData.content}
            handleClose={() => setAlertOpen(false)}
        />
        <NormalDialog
            open={stagetwoUploadDialogOpen}
            dialogTitle={`Select Attachment(s) Type`}
            button={[]}
            size={"lg"}
            height={700}
            formContent={<PilStageTwoUploadDetails
                stageTwoFiles={stageTwoFiles}
                setStageTwoFiles={setStageTwoFiles}
                stagetwoDialogHandleClose={stagetwoDialogHandleClose}
                pilDetails={pilDetails}
                setUpdateFlag={setUpdateFlag}
                buildAlert={buildAlert}
                setLockScreenLoadingOpen={setLockScreenLoadingOpen}
            />}
            handleClose={stagetwoDialogHandleClose}
        />

        <ConfirmDialog
            open={confirmDialogOpen}
            dialogTitle={confirmDialogData.dialogTitle}
            dialogContent={confirmDialogData.dialogContent}
            confirmAction={confirmDialogData.confirmAction}
            cancelAction={confirmDialogData.cancelAction}
        />
        <FullScreenDialog
            open={filePreviewDialogOpen}
            dialogTitle={"Project Information List Preview"}
            formContent={<FilePreview filePreviewProperty={filePreviewProperty}/>}
            button={fileAttachmentPreviewDialogBtn}
            handleClose={filePreviewDialogHandleClose}
        />
        <Stack spacing={2}>

            <ToggleButtonGroup
                style={{border: "1px solid rgb(182 207 237)"}}
                value={stage}
                size={"small"}
                color="primary"
                exclusive
                onChange={handleToggleChange}
            >
                <ToggleButton value="1">Stage One</ToggleButton>
                {/*
                {pilDataRedux !== null &&
                    pilDataRedux.uploadFiles &&
                    pilDataRedux.uploadFiles.filter((a) => a.stage === "1" && a.status === "Y").length >
                    0 && <ToggleButton value="2">Stage Two</ToggleButton>}
                */}
                <ToggleButton value="2">
                    <Tooltip
                        title={stage === "1" && !(pilDataRedux !== null && pilDataRedux.uploadFiles && pilDataRedux.uploadFiles.filter((a) => a.stage === "1" && a.status === "Y").length > 0) ? "Please upload signed Project Information List to stage one first" : ""}
                        arrow>
                        <span>Stage Two</span>
                    </Tooltip>
                </ToggleButton>

            </ToggleButtonGroup>
            {stage === "1" ? (<Grid item xs={12}>
                <Legend
                    id="attachment"
                    label="ATTACHMENT "
                    normalTitleColor={"gray"}
                    normalBorderColor={"#becedf"}
                >
                    <FileDropzone
                        key={"pil_attachment"}
                        title={""}
                        fileType={"pil_attachment"}
                        disabled={lock}
                        uploadable={uploadable}
                        fileUploadAction={fileUploadAction}
                        fileRemoveAction={removeFileConfirmAction}
                        viewFileAction={viewFileAction}
                        DropzoneContent={PilFileZoneContentStageOne}
                    />
                </Legend>
            </Grid>) : (<Grid item xs={12}>
                <Legend
                    id="attachment"
                    label="ATTACHMENT "
                    normalTitleColor={"gray"}
                    normalBorderColor={"#becedf"}
                >
                    {/*
                        <PilStageTwoFileDropzone
                            key={"pil_attachment"}
                            title={""}
                            fileType={"pil_attachment"}
                            fileArray={stageTwoFiles}
                            disabled={false}
                            fileUploadAction={fileUploadAction}
                            fileRemoveAction={removeFileConfirmAction}
                            viewFileAction={viewFileAction}
                            DropzoneContent={PilFileZoneContentStageTwo}
                        />
                        */}

                    <ProjectInformationStageTwoForm
                        setUpdateFlag={setUpdateFlag}
                        pilDetails={pilDataRedux}
                        uploadable={uploadable}
                        stage={stage}
                        lock={lock}
                    />
                </Legend>
            </Grid>)}
        </Stack>
    </Fragment>);
};

export default PilFileHistory;
